export type CharBarSeverity = "ok" | "warn" | "danger";

/** Severity of the footer char bar: amber above 75%, red above 90%. */
export const getCharBarSeverity = (charCount: number, limit: number): CharBarSeverity => {
	if (limit <= 0) {
		return "ok";
	}

	const pct = (charCount / limit) * 100;

	if (pct > 90) {
		return "danger";
	}

	if (pct > 75) {
		return "warn";
	}

	return "ok";
};

/** Fill width of the footer char bar, capped at 100%. */
export const getCharBarWidthPct = (charCount: number, limit: number): number => {
	if (limit <= 0) {
		return 0;
	}

	return Math.min(100, Math.round((charCount / limit) * 100));
};
